var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3788 6.70698C15.1885 5.75459 13.7434 5 12 5C7.85787 5 4.5 8.35786 4.5 12.5C4.5 16.6421 7.85787 20 12 20C15.2549 20 18.028 17.9254 19.0646 15.0256C19.2505 14.5055 19.775 14.1568 20.3153 14.2713L21.2935 14.4787C21.8338 14.5932 22.1836 15.1262 22.0179 15.6531C20.6787 19.9112 16.7016 23 12 23C6.20101 23 1.5 18.299 1.5 12.5C1.5 6.70101 6.20101 2 12 2C14.7835 2 16.9516 3.26847 18.5112 4.5746L20.2929 2.79289C20.5789 2.50689 21.009 2.42134 21.3827 2.57612C21.7564 2.7309 22 3.09554 22 3.5V9C22 9.55228 21.5523 10 21 10H15.5C15.0956 10 14.7309 9.75636 14.5761 9.38268C14.4214 9.00901 14.5069 8.57889 14.7929 8.29289L16.3788 6.70698Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshArrow);
export default __webpack_public_path__ + "static/media/refresh-arrow.17595b059c6b45cf0b3e68bc6d8ae738.svg";
export { ForwardRef as ReactComponent };